/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var AllNotificationsType;
(function (AllNotificationsType) {
    AllNotificationsType["STORE_AVAILABILITY"] = "STORE_AVAILABILITY";
    AllNotificationsType["WEEKLY_DEBRIEF"] = "WEEKLY_DEBRIEF";
    AllNotificationsType["STORE_PERFOMANCE_REPORT"] = "STORE_PERFOMANCE_REPORT";
    AllNotificationsType["POPCHEW_STORE_PERFORMANCE_REPORT"] = "POPCHEW_STORE_PERFORMANCE_REPORT";
    AllNotificationsType["CHARGEBACK_SUMMARY"] = "CHARGEBACK_SUMMARY";
    AllNotificationsType["UNMAPPED_GL_ACCOUNTING_COMPANIES"] = "UNMAPPED_GL_ACCOUNTING_COMPANIES";
    AllNotificationsType["ACCOUNTING_ACCESS_LOST"] = "ACCOUNTING_ACCESS_LOST";
    AllNotificationsType["DIGITAL_STORES_ACCESS_LOST"] = "DIGITAL_STORES_ACCESS_LOST";
    AllNotificationsType["UNMAPPED_STORES"] = "UNMAPPED_STORES";
    AllNotificationsType["REVIEW_SUMMARY_REPORT"] = "REVIEW_SUMMARY_REPORT";
    AllNotificationsType["ISSUE_DISCOVERY"] = "ISSUE_DISCOVERY";
    AllNotificationsType["ISSUE_DISCOVERY_ALERTS"] = "ISSUE_DISCOVERY_ALERTS";
    AllNotificationsType["PLAID_ACCESS_LOST"] = "PLAID_ACCESS_LOST";
    AllNotificationsType["STORE_AVAILABILITY_DIGEST"] = "STORE_AVAILABILITY_DIGEST";
    AllNotificationsType["DISPUTES_OPT_OUT"] = "DISPUTES_OPT_OUT";
    AllNotificationsType["ACCOUNTING_PUSH"] = "ACCOUNTING_PUSH";
    AllNotificationsType["ACCOUNTING_PRE_PUSH"] = "ACCOUNTING_PRE_PUSH";
    AllNotificationsType["STORE_AVAILABILITY_REALTIME"] = "STORE_AVAILABILITY_REALTIME";
    AllNotificationsType["GUARD_SUMMARY"] = "GUARD_SUMMARY";
    AllNotificationsType["CHAIN_ENGAGEMENT"] = "CHAIN_ENGAGEMENT";
    AllNotificationsType["RECOVER_ORDER_SUMMARY"] = "RECOVER_ORDER_SUMMARY";
    AllNotificationsType["RECOVER_LOCATION_SUMMARY"] = "RECOVER_LOCATION_SUMMARY";
    AllNotificationsType["UPTIME_BY_LOCATION"] = "UPTIME_BY_LOCATION";
})(AllNotificationsType || (AllNotificationsType = {}));
